import { commonRowAndCellClassRules } from '../../../../components/grid/classRules/classRules';
import defaultObjEquals from '../../../../components/grid/columnDefaults/defaultObjEquals';
import defaultSetFilterParams from '../../../../components/grid/columnDefaults/defaultSetFilterParams';
import allowUpAndDownOnEdit from '_legacy/components/grid/columnDefaults/allowUpAndDownOnEdit';
import {
    DefaultTankTypeMapping,
    FetchMappingSelectTankTypeDisplayValue,
} from '_legacy/data/mappings';
import SelectEditor from '_legacy/modules/shared/columns/editors/SelectEditor';
import {
    TankTypeFilterFormatter,
    TankTypeFormatter,
} from '_legacy/components/grid/formatters/TankTypeFormatter';
import TankTypeComparator from '_legacy/components/grid/comparators/TankTypeComparator';

export const vesselTankTypeHeading = {
    colId: 'tankTypeCode',
    headerName: 'Tank Type',
    field: 'vessel.tankTypeCode',
    cellEditorFramework: SelectEditor,
    cellEditorParams: {
        values: DefaultTankTypeMapping.map((m) => m.id),
        formatValue: FetchMappingSelectTankTypeDisplayValue,
    },
    suppressKeyboardEvent: allowUpAndDownOnEdit(),
    valueFormatter: TankTypeFormatter,
    editable: false,
    comparator: TankTypeComparator,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: TankTypeComparator,
        valueFormatter: TankTypeFilterFormatter,
    },
    tooltipValueGetter: (params) =>
        FetchMappingSelectTankTypeDisplayValue(params.value),
    equals: defaultObjEquals,
    hide: true,
    width: 120,
};
